import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, getTypographyStyles, SEM_TYPOGRAPHY_FORMS_APPENDIX, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL, SYS_BORDER_RADIUS_SM, SYS_BORDER_WIDTH_100, SYS_SIZE_FIXED_1200, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_200 } from '@oneaudi/unified-web-alpha-common';
import { FormMessage } from '../form-message/index.js';
import { Icon } from '../icon/index.js';
const ICON_WIDTH = '24px';
const ICON_SPACING = `calc(${ICON_WIDTH} + ${SYS_SPACE_FIXED_100} + ${SYS_SPACE_FIXED_200})`;
export const StyledIcon = styled(Icon) `
  position: absolute;
  pointer-events: none;
  left: ${SYS_SPACE_FIXED_150};
  top: 50%;
  transform: translateY(-50%);
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.icon.disabled
    : props.theme.sem.color.forms.foreground.field.icon.default};
`;
export const StyledChevron = styled(Icon) `
  pointer-events: none;
  flex-shrink: 0;
  right: ${SYS_SPACE_FIXED_200};
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
  pointer-events: none;
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.icon.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.field.icon.error
        : props.theme.sem.color.forms.foreground.field.icon.default};

  // TODO: tokens missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: color, transform;
`;
export const StyledSelectField = styled.div `
  margin: ${(props) => getMargins(props.margin)};
`;
export const StyledLabel = styled.label `
  display: flex;
  align-items: baseline;
  gap: ${SYS_SPACE_FIXED_100};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)}
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.label.disabled
    : props.theme.sem.color.forms.foreground.field.label.default};
  padding-bottom: ${SYS_SPACE_FIXED_100};
`;
export const StyledAppendix = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_APPENDIX)}
  color: ${(props) => props.$disabled
    ? props.theme.sem.color.forms.foreground.field.appendix.disabled
    : props.theme.sem.color.forms.foreground.field.appendix.default};
`;
export const StyledSelectContainer = styled.div `
  position: relative;
`;
export const StyledSelect = styled.select `
  ${(props) => !props.$readOnly &&
    css `
      &:not(:disabled) {
        background: ${props.theme.sem.color.forms.surface.field.fill.default};
        ${css `
          box-shadow: 0px 0px 0px ${SYS_BORDER_WIDTH_100}
            ${props.invalid
        ? props.theme.sem.color.forms.surface.field.stroke.error
        : props.theme.sem.color.forms.surface.field.stroke.default};
        `}
      }
    `}

  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)};
  color: ${(props) => props.$empty
    ? props.theme.sem.color.forms.foreground.field.placeholder.default
    : props.theme.sem.color.forms.foreground.field.input.default};
  width: 100%;
  min-height: ${SYS_SIZE_FIXED_1200};
  box-sizing: border-box;
  ${(props) => css `
    padding: ${SYS_SPACE_FIXED_150} ${ICON_SPACING} ${SYS_SPACE_FIXED_150}
      ${props.icon ? ICON_SPACING : SYS_SPACE_FIXED_150};
  `}
  border: none;
  border-radius: ${SYS_BORDER_RADIUS_SM};
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  // TODO: tokens missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: background, box-shadow;

  ${(props) => !props.$readOnly &&
    css `
      &:hover:not(:disabled),
      &:active:not(:disabled) {
          background: ${props.theme.sem.color.forms.surface.field.fill.interactive};
          box-shadow: 0px 0px 0px ${SYS_BORDER_WIDTH_100}
            ${props.invalid
        ? props.theme.sem.color.forms.surface.field.stroke.error
        : props.theme.sem.color.forms.surface.field.stroke.interactive};
       
         };
      }

      &:focus:not(:disabled) {
          background: ${props.theme.sem.color.forms.surface.field.fill.focus};
          box-shadow: 0px 0px 0px ${SYS_BORDER_WIDTH_100}
            ${props.invalid
        ? props.theme.sem.color.forms.surface.field.stroke.error
        : props.theme.sem.color.forms.surface.field.stroke.focus};
      }

      &:disabled {
        background: ${props.theme.sem.color.forms.surface.field.fill.disabled};
          cursor: not-allowed;
        box-shadow: 0px 0px 0px ${SYS_BORDER_WIDTH_100} ${props.theme.sem.color.forms.surface.field.stroke.disabled};
        color: ${props.$empty
        ? props.theme.sem.color.forms.foreground.field.placeholder.disabled
        : props.theme.sem.color.forms.foreground.field.input.disabled};
      }
    `}

  ${(props) => props.$readOnly &&
    css `
      background: ${props.theme.sem.color.forms.surface.field.fill.readOnly};
      box-shadow: 0px 0px 0px ${SYS_BORDER_WIDTH_100}
        ${props.theme.sem.color.forms.surface.field.stroke.readOnly};
    `}
`;
export const StyledFormMessage = styled(FormMessage) `
  padding-top: ${SYS_SPACE_FIXED_100};
`;
//# sourceMappingURL=index.styles.js.map